<template lang="html">
  <div class="team">
    <h2 class="no-margin mb-10">{{ $t('team_info') }}</h2>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">{{ $t('dashboard') }}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/teams' }">{{ $t('teams') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.query.name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="line"></div>
    <info v-if="self !== null"/>
  </div>
</template>

<script>
import Info from '@/components/team/Info'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'self'
    ])
  },
  components: {
    Info
  }
}
</script>

<style lang="css">
</style>
